export const Logo = ({ size = 40, light = false }) => (
  <img
    src="/logo-mark.png"
    alt="Marcio Pissaia — Cabeleireiro Unissex"
    width={size}
    height={size}
    style={{ width: size, height: size, objectFit: "contain" }}
    className={`shrink-0 ${light ? "bg-white rounded-lg p-0.5" : ""}`}
  />
);
